import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default (WrappedComponent) => {
    class TrackPlayerSlideComponent extends Component {
        static propTypes = {
            onEnter: PropTypes.func
        };

        componentDidMount() {
            const { onEnter } = this.props;
            if (onEnter) {
                onEnter();
            }
        }

        render() {
            const { onEnter, ...rest } = this.props;
            return <WrappedComponent {...rest} />;
        }
    }

    return TrackPlayerSlideComponent;
};
